// extracted by mini-css-extract-plugin
export default {"wrapper":"marker_wrapper__s6ZUc"};